// 사용자 역할 상수 정의
export const UserRole = {
  USER: 'user',
  ADMIN: 'admin',
  SUPER: 'super',
} as const;

// 사용자 역할 타입 추출
export type UserRole = typeof UserRole[keyof typeof UserRole];

export interface LoginFormData {
  email: string;
  password: string;
}

// 관리자 페이지용 사용자 인터페이스
export interface FirebaseUser {
  uid: string;
  email: string;
  displayName: string | null;
  photoURL: string | null;
  role: UserRole;
  customClaims?: Record<string, unknown>;
  disabled: boolean;
  createdAt: string;
  lastSignInTime: string | null;
}

// 사용자 Custom Claims 인터페이스 (role만 관리, 구독 정보는 Firestore에서 관리)
export interface CustomClaims {
  role: UserRole;
}